import { render, staticRenderFns } from "./FSP.vue?vue&type=template&id=13681eb2&scoped=true&"
import script from "./FSP.vue?vue&type=script&lang=js&"
export * from "./FSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13681eb2",
  null
  
)

export default component.exports